import React from 'react';
import { FormControl, FormGroup, Label } from 'components/form/Formik';
import { Field } from 'formik';

function UTMInput(sms) {
  return [
    <div key="email" hidden={sms}>
      <FormGroup>
        <Label htmlFor="emailUtm">UTM</Label>
        <FormControl>
          <Field id="emailUtm" name="emailUtm" placeholder="" type="text" textDirection="ltr" />
        </FormControl>
      </FormGroup>
    </div>,
    <div key="sms" hidden={!sms}>
      <FormGroup>
        <Label htmlFor="smsUtm">UTM</Label>
        <FormControl>
          <Field id="smsUtm" name="smsUtm" placeholder="" type="text" textDirection="ltr" />
        </FormControl>
      </FormGroup>
    </div>
  ];
}

export default UTMInput;
